import { render } from "./EditCommunityView.vue?vue&type=template&id=725d71c4"
import script from "./EditCommunityView.vue?vue&type=script&lang=js"
export * from "./EditCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__